<template>
    <div class="main-mistakeWeekday">

      <main>
        <header>
          <h3>日历管理</h3>
          <!-- <span>/ computer management</span> -->
          <div class="btn-group">
            <a-button v-if="$IA('system:calendar:save')" type="primary" icon="plus" @click="handleOpen('添加')">添加
            </a-button>
          </div>
        </header>
        <!-- 表格搜索栏 -->
        <div class="toolbar">
          <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
            <a-form-model-item prop="searchText">
              <a-input-search placeholder="名称" v-model.trim="pagination.searchText" @input="searchTextChange"  allow-clear
                              :loading="btnLoad" />
            </a-form-model-item>
            <a-form-model-item  prop="orgId">
              <a-select v-model="pagination.orgId" placeholder="部门" style="width: 180px;" allowClear
                        :loading="btnLoad" @change="searchChange" show-search  :filter-option="filterOption">
                <a-select-option  v-for="item in orgList" :value="item.id">{{item.name}}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item >
              <a-button  @click="resetSearch">重 置</a-button>
            </a-form-model-item>
          </a-form-model>

        </div>

        <!-- 数据表格 -->
        <a-table :loading="tableLoad" bordered :columns="tableColumns" :data-source="tableData" @change="handleTableChange"
          :pagination="queryCondition" :scroll="{ y: 560 }">
          <span slot="customTitle">名称</span>
          <span slot="action" slot-scope="text, record" class="table-action-box">
               <a-tooltip  content="" v-if="$IA('system:calendar:update')" title="修改" placement="top" effect="light">
                  <i class="table-edit" @click="handleOpen('修改', record)" ></i>
                </a-tooltip>
                <a-tooltip  content="" v-if="$IA('system:calendar:delete')" title="删除" placement="top" effect="light">
                  <i class="table-delected" @click="handleOpen('删除', record)" ></i>
                </a-tooltip>
                <a-tooltip  content="" v-if="$IA('system:calendar:delete')" title="查看" placement="top" effect="light">
                  <i class="table-view" @click="viewOpen('查看', record)" ></i>
                </a-tooltip>
          </span>
        </a-table>
      </main>
  
      <!-- 操作模态框 -->
      <a-modal centered :title="modalTitle + '日历'" :visible="modalVisible" :confirm-loading="submitLoad" @ok="handleOk"
        @cancel="resetForm"   ok-text="提交" :maskClosable="false"       :width="modalTitle == '删除' ? '420px' : '520px'">

        <a-form-model  layout="vertical" :model="addForm" :rules="addFormRules"
        ref="addForm" v-if="this.modalTitle !== '删除'">
          <a-form-model-item prop="id" v-show="false">
            <a-input v-model="addForm.id" placeholder="请输入" />
          </a-form-model-item>
          <a-form-model-item label="名称" prop="name" class="mistake-download">
            <a-input v-model="addForm.name" placeholder="请输入" />
            <!-- <a href="">下载CSV模板</a> -->
            <a download="日历模板.csv" :href="'data:text/csv;charset=utf-8,'+'%EF%BB%BF%E9%9D%9E%E5%B7%A5%E4%BD%9C%E6%97%A5'+'\n'+$moment().add(1, 'day').format('YYYY-MM-DD')+'\n'+$moment().add(2, 'day').format('YYYY-MM-DD')+'\n'+$moment().add(3, 'day').format('YYYY-MM-DD')">下载CSV模板</a>
          </a-form-model-item>
          <a-form-model-item label="部门" prop="orgId" >
            <a-select v-model="addForm.orgId" placeholder="请选择" :disabled="modalTitle == '修改'" show-search  :filter-option="filterOption">
              <a-select-option v-for="v in orgList" :key="v.id" :value="v.id">
              {{ v.name }}
              </a-select-option>
          </a-select>
            </a-form-model-item>
            <div :style="{  border: '1px solid #d9d9d9', borderRadius: '4px' }" class="mistake-calendar">
              <div class="mistake-operate">
                <p>手动选择以下日期或</p>   
                <a-upload name="file" :multiple="false" :action="batchImportApi" :fileList="completeFileList"
                :headers="{ Authorization: $store.state.user.token }" accept='.csv'  @change="handleUpload">
                <a-button type="primary" icon="cloud-download" style="color: #ffffff">
      
                 {{ csvfileList ?fileLabel(csvfileList.name) :"上传 csv" }}
                </a-button>

              </a-upload>

              </div>
              <a-calendar :fullscreen="false" :disabledDate="disabledDate" v-model="calendarValue"  @select="onSelect">
                <template slot="dateFullCellRender" slot-scope="value">
                  <div :class="(calendarData.includes($moment(value).format('YYYY-MM-DD'))?'calendar-value':'')+' ant-fullcalendar-date'">
                    <div class="ant-fullcalendar-value">{{ $moment(value).format('DD') }}</div>
                  </div>
                </template> 
              </a-calendar>
            </div>
        
          <a-form-model-item label="描述" prop="description">
            <a-textarea v-model="addForm.description" placeholder="请输入" />
          </a-form-model-item>
      </a-form-model>

        <div class="deleteBox" v-if="modalTitle == '删除'">
          <a-icon type="exclamation-circle" theme="filled" />
          <p>此操作将永久删除该日历,是否继续?</p>
        </div>

      </a-modal>

      <a-modal centered  :visible="viewVisible" :footer="null"  :confirm-loading="submitLoad" @ok="handleOk"
               @cancel="viewResetForm"   ok-text="提交" :maskClosable="false">

        <template slot="title">
          <span class="el-dialog__title">
            查看：{{modalTitle}}
            <a-tooltip  content="" placement="top" effect="light">
               <template slot="title">
                 <span> 标记选中的日期为不会执行的日期</span>
               </template>
              <i class="el-icon-warning" style="color: #E6A23C;"></i>
            </a-tooltip>
          </span>
        </template>


       <div style="display: flex;justify-content: space-between;margin-bottom: 20px">
         <a-range-picker :value="viewPagination.time" v-model="viewPagination.time"
                         :placeholder="['开始日期: 开始', '结束日期: 结束']"   valueFormat="YYYY-MM-DD" style="width: 250px;" @change="viewSearchChange" />

         <a-popconfirm
             title="导出的表格数据量最大支持5000条，确定要导出吗？"
             ok-text="确定"
             cancel-text="取消"
             @confirm="exportQuery"
         >
           <a-button  icon="download"   type="primary" >导出</a-button>
         </a-popconfirm>
       </div>
        <a-table :columns="viewTableColumns" :data-source="viewTableData" @change="viewHandleTableChange"
                 :pagination="viewQueryCondition"  style="padding-bottom: 20px;">
        </a-table>
      </a-modal>

    </div>
  </template>
  
  <script>
  import {notification} from "ant-design-vue";

  export default {
    data() {
      return {
        num:0,
        btnLoad: false,
        tableLoad: false,
        submitLoad:false,
        pagination: {
          searchText: "",
          pageSize: 10,
          pageNo: 1,
          total: 0,
          orgId:undefined,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '40', '50'],
          showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
        },
        formLayout: "inline",
        queryCondition: {},
        tableColumns: [
          {
            title: "序号",
            dataIndex: "index",
            key: "index",
            align: "center",
            width: 65,
            customRender: (text, record, index) => `${index + 1}`,
          },
          {
            dataIndex: "name",
            key: "name",
            slots: { title: "customTitle" },
            scopedSlots: { customRender: "name" },
            ellipsis: true,
          },
          {
            title: "描述",
            dataIndex: "description",
            key: "description",
            ellipsis: true,
          },
          {
            title: "部门",
            key: "orgName",
            dataIndex: "orgName",
            ellipsis: true,
          },
          {
            title: "创建人",
            dataIndex: "nickName",
            key: "nickName",
            ellipsis: true,
          },
          {
            title: "创建时间",
            dataIndex: "createTime",
            key: "createTime",
            ellipsis: true,
          },
          {
            title: "操作",
            key: "action",
            scopedSlots: { customRender: "action" },
            align: "center",
            width: 120,
          },
        ],
        tableData: [],
        singleDta:{},
        // 模态框显隐
        modalVisible: false,
        // 模态框标题
        modalTitle: "",
        // 添加表单
        addForm: {
          id:"",
          name: "",
          unWorkDates:[],
          orgId:undefined,
          description: "",
        },
        // 部门列表
        orgList:[],
        completeFileList: [],
        addFormRules:{
          name: [{ required: true, max: 20, message: '名称最长不能超过20字符且不可为空' }],
          orgId: [{ required: true, message: "部门不能为空" }],
        },
        calendarData:[],
        calendarValue:'',
        batchImportApi: this.axios.defaults.baseURL + "/calendar/getCsvDate",
        // 回显csv文件
        csvfileList:'',
        // 分页参数
        pagCurrent:'',


        // 查看
        viewVisible:false,

        // 开始日期
        viewTableData:[],
        viewQueryCondition:{},
        viewPagCurrent:'',
        viewPagination: {
          id:'',
          pageSize: 10,
          pageNo: 1,
          total: 0,
          time:[],
          orgId:undefined,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '40', '50'],
          showTotal: (total, range) => `共 ${total} 条记录  `
        },
        viewTableColumns: [
          {
            title: "序号",
            dataIndex: "index",
            key: "index",
            align: "center",
            width: 60,
            customRender: (text, record, index) => `${index + 1}`,
          },
          {
            title: "日期",
            dataIndex: "date",
            key: "date",
            scopedSlots: { customRender: "date" },
            ellipsis: true,
          },
        ],
      };
    },
    methods: {
      // 搜索
      filterOption(input, option) {
        return (
            option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      fileLabel(title){
          if (title.length>15) {
            return  title.slice(0,15)+'...'
          }else{
            return  title
          }
      },
      // 重置表单通用方法
      resetForm() {
        if (this.modalTitle != '删除' ) {
          this.$refs.addForm.resetFields()
        }
        this.modalVisible = false
        this.completeFileList = []
        this.csvfileList = ''
      },

      // 重置搜索
      resetSearch() {
        this.$refs.searchBar.resetFields()
        this.pagination.current = 1
        this.searchChange()
      },
      searchTextChange(val){
        if (window.searchTimer) {
        clearTimeout(searchTimer);
        }
        window.searchTimer = setTimeout(() => {
          this.searchChange(val)
        }, 1200);
      },
      // 部门下拉框
      allorgList() {
      this.axios
        .post("/org/findParentOrg",'')
        .then((res) => {
          if (res.code === 200) {
            this.orgList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    disabledDate(current) {
      if ( this.modalTitle == '添加') {
        return current && current < this.$moment().subtract(1, 'day').endOf('day');
      }

    },
    // 导出
    exportQuery(){
      let exportParam = this.$lodash.cloneDeep(this.viewQueryCondition)

      this.axios.post('/calendar/exportDateList',  exportParam, { responseType: 'blob' }).then((res)=>{
        const blob = new Blob([res], {
          type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
        });
        console.log(blob)
        if (window.navigator.msSaveBlob) {          //IE兼容处理
          try {
            window.navigator.msSaveBlob(blob,'expore'+'.csv');
          } catch (e) {
            console.log(e);
          }
        } else {
          const url = window.URL.createObjectURL(blob);
          const aLink = document.createElement("a");
          aLink.style.display = "none";
          aLink.href = url;
          aLink.setAttribute("download", 'expore'+'.csv');
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      }).catch((err)=>{
        console.log(err.message);
      })

    },
    viewResetForm(){
      this.viewVisible = false
      this.viewPagination.time = []
    },
    // 查看日历
    viewOpen(title,data){
      this.modalTitle = data.name
      this.viewVisible = true
      this.viewPagination.id = data.id
      this.viewSearchChange()
    },
    viewSearchChange(v) {
      this.viewQueryCondition = this.$lodash.cloneDeep(this.viewPagination)
      this.viewTableAjax()
    },
    // 监听翻页
    viewHandleTableChange(pagination, filters, sorter) {
      this.viewQueryCondition.pageNo =   pagination.current ? pagination.current : 1
      this.viewQueryCondition.current =  pagination.current ? pagination.current : 1
      this.viewQueryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.viewPagCurrent = pagination ? pagination : this.viewPagination
      this.viewTableAjax()
    },
    // 翻页请求
    viewTableAjax() {
    this.tableLoad = true;
    this.axios
        .post("/calendar/getDatePage", this.viewQueryCondition)
        .then((res) => {
          this.tableLoad = false;
          if (res.code === 200) {
            this.viewTableData = res.data.records;
            this.viewQueryCondition.total = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
          this.tableLoad = false;
        });
    },
    // 打开模态框
    handleOpen(title, data) {
      this.modalTitle = title
      this.modalVisible = true
      this.calendarData = []
      this.calendarValue = this.$moment().format('YYYY-MM')
      this.$nextTick(()=>{
        this.singleDta = data;
        switch (title) {
          case "添加":
          this.calendarData = this.$moment().format('YYYY-MM-DD')
          this.calendarData = this.calendarData.split(',')
          this.addForm.unWorkDates = this.$moment().format('YYYY-MM-DD')
          this.addForm.unWorkDates = this.addForm.unWorkDates.split(',')
            break;
          case "修改":
            this.addForm = this.$lodash.pick(
              this.singleDta,
              this.$lodash.keys(this.addForm)
            );
            this.axios
                .post("calendar/getCalendar",{id:  this.addForm.id})
                .then((res) => {
                  if (res.code === 200) {
                    this.calendarData = res.data.unWorkDates
                    this.addForm.unWorkDates = res.data.unWorkDates
                    console.log(  this.addForm.unWorkDates )
                  }
                })
                .catch((err) => {
                  console.log(err);
                });



            break;
          case "删除":
            break;
        }
     })
    },
    // 确认模态框
    handleOk() {
      if (this.modalTitle == '添加' || this.modalTitle == '修改') {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.submitLoad = true;
            let saveData = "";
            saveData = this.$lodash.cloneDeep(this.addForm);

            // 过滤今日之前的非工作日数据
            saveData.unWorkDates = saveData.unWorkDates.filter((x)=>{
              return this.$moment(x).isSameOrAfter(new Date(),'day')
            })
            this.axios
              .post("/calendar/" + (this.modalTitle == '修改' ? 'update' : 'save'), saveData)
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  this.modalVisible = false
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                  this.resetForm()
                  this.tableAjax()
                }
              })
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
          }
        });
      }
      if (this.modalTitle == '删除') {
        this.submitLoad = true;
          this.axios
            .delete("/calendar/delete/" + this.singleDta.id)
            .then((res) => {
              this.submitLoad = false
              if (res.code === 200) {
                this.modalVisible = false;
                notification.success({
                  message: res.message,
                  duration: 3,
                  customClass: "batch-import",
                })
                this.handleTableChange(this.pagCurrent);
                }
            })
            .catch((err) => {
              this.submitLoad = false
              console.log(err);
            });
      }
    },
    // 日历监听
    onSelect(value, mode){
      if (this.calendarData.includes(this.$moment(value._d).format('YYYY-MM-DD'))) {
        this.calendarData  = this.calendarData.filter((item)=> {
          return item !== this.$moment(value._d).format('YYYY-MM-DD')
        }); 
        this.addForm.unWorkDates =  this.calendarData
      }else{
        this.calendarData.push(this.$moment(value._d).format('YYYY-MM-DD'))
        this.calendarData = Array.from(new Set(this.calendarData ))
        this.addForm.unWorkDates =  this.calendarData
      }
    },
    // 选择文件上传
    handleUpload(info) {
      let fileList = [...info.fileList];
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });
      this.completeFileList = fileList;
      this.csvfileList = this.completeFileList[this.completeFileList.length-1]
      if (info.file.status === 'done') {
        switch (info.file.response.code) {
          case 200:
            this.addForm.unWorkDates = info.file.response.data
            this.$message.success(info.file.response.message);
            break;
          case 500:
            this.completeFileList = []
            this.$message.warning(info.file.response.message);
            break;
        }
      }
    },
    // 判断是否上传文件
    beforeUpload(file) {
      this.completeFileList = [...this.completeFileList, file];
      // //限制文件只能上传一个
      this.completeFileList = this.completeFileList.slice(-1);
      return false;
    },

    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      this.tableAjax()
    },
    // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo =   pagination.current ? pagination.current : 1
      this.queryCondition.current =  pagination.current ? pagination.current : 1
      this.queryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.pagCurrent = pagination ? pagination : this.pagination
      this.tableAjax()
    },
    // 翻页请求
    tableAjax() {
      this.tableLoad = true;
      this.axios
        .post("/calendar/findPage", this.$qs.stringify(this.queryCondition))
        .then((res) => {
          this.tableLoad = false;
          if (res.code === 200) {
            this.tableData = res.data.records;
            this.queryCondition.total = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
          this.tableLoad = false;
        });
    },
  },
    beforeMount() {
      this.searchChange();
      this.allorgList()
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .main-mistakeWeekday {


    main {
      margin: 16px;
      background-color: #fff;
      border-radius: 2px;

      header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px;
        border-bottom: 1px solid #f0f0f0;

        h3 {
          margin-bottom: 0;
          height: 18px;
          line-height:17px;
          padding-left: 12px;
          border-left: 4px solid #3373F2;
          font-size: 16px;
          font-weight: bold;
          color: #3d4966;
        }

        span {
          line-height: 16px;
          margin-left: 10px;
          color: #808080;
        }
      }


      .toolbar {
        display: flex;
        justify-content: space-between;
        padding: 16px;

        .search-bar {
          flex: 1;
        }
        .ant-form{
          .ant-form-item{
            margin-right: 16px;
          }
          .ant-form-item:last-child{
            .ant-btn{
              width: 74px;
              position: absolute;

            }
          }
        }
      }
  
      .ant-tag {
        border-radius: 16px;
      }
      .ant-table-wrapper{
        padding: 0 16px 16px;
      }
    }
  }
  
  .ant-operation-menu {
    display: flex;
  
    i {
      margin-top: 5px;
      font-size: 18px;
    }
  }
  
  ::v-deep .version {
    .anticon {
      margin-right: 5px;
      color: #fa9635;
    }
  }
  .mistake-download{
    position: relative;
    a{
      position: absolute;
      display: inline-block;
      width: 120px;
      right: -38px;
      top: -35px;     
      font-weight: 600;
    }
  }
  .mistake-calendar{
    margin-bottom: 20px;
    .mistake-operate{
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 10px 0px;
      p{
        margin-bottom: 0px;
        margin-right: 10px;
      }
      .ant-btn{
        height: 30px;
        background-color: #f2f8fd;
        color: #3373f2;
       ::v-deep .ant-btn .anticon{
          color: #3373f2;
        }
      }
    }
      ::v-deep  .ant-select{
          width: 100px;
        }
  }
  
   .ant-fullcalendar-selected-day{
     .ant-fullcalendar-value:active{
        background: transparent;
        color: rgba(0, 0, 0, 0.65);
      }
      .ant-fullcalendar-value{
        background: transparent;
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .calendar-value{
      .ant-fullcalendar-value{
        color: #fff;
        background: #1890ff;
      }
      
    }
   ::v-deep .ant-upload-list{
      display: none;
    }
  </style>
  